import { useTranslation } from 'src/hooks/use-translation';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';

import { useOffSetTop } from 'src/hooks/use-off-set-top';

import { bgBlur } from 'src/theme/css';
import { SUPPORT_CONTACT_URL } from 'src/config-global';

import { Logo } from 'src/components/logo';

import { HEADER } from 'src/layouts/config-layout';
import { HeaderShadow } from './header-shadow';

// ----------------------------------------------------------------------

export function HeaderSimple() {
  const theme = useTheme();
  const { t } = useTranslation('', { keyPrefix: 'header' });

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo fullIcon height="35px" width="auto" />

        <Stack direction="row" alignItems="center" spacing={1}>
          <Link
            href={SUPPORT_CONTACT_URL}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            sx={{ typography: 'subtitle2' }}
          >
            {t('help')}
          </Link>
        </Stack>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
